import PocketBase from 'pocketbase';

const POCKETBASE_URL = process.env.VUE_APP_POCKETBASE_URL;

const pb = new PocketBase(POCKETBASE_URL);
export default pb;